import styles from './ProblemsSolvedDivider.module.css';

export const ProblemsSolvedDivider = () => {
  return <div className={styles.problemsSolvedDivider} />;
};
